import { TypeCompiler } from '@sinclair/typebox/compiler';

import { DayOfMonthSchedule } from '../schema/day-of-month-schedule.schema';

export const DayOfMonthScheduleValidator =
  TypeCompiler.Compile(DayOfMonthSchedule);
